<template>
  <div id="page-competition-edit">

    <vs-alert color="danger" title="Competition Not Found" :active.sync="competition_not_found">
      <span>Competition with link: {{ $route.params.link }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'app-competition-list'}" class="text-inherit underline">All Competitions</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="competition_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <tab-competition class="mt-4" :data="competition_data" />
            </div>
          </vs-tab>
          <vs-tab label="Tickets" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <user-edit-tab-information class="mt-4" :data="competition_data" />
            </div>
          </vs-tab>
          <vs-tab label="Charity" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <user-edit-tab-social class="mt-4" :data="competition_data" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import TabCompetition     from "./TabCompetition.vue"
import UserEditTabInformation from "./UserEditTabInformation.vue"
import UserEditTabSocial      from "./UserEditTabSocial.vue"

export default {
  components: {
    TabCompetition,
    UserEditTabInformation,
    UserEditTabSocial,
  },
  data() {
    return {
      competition_data: null,
      competition_not_found: false,
      activeTab: 0,
    }
  },
  watch: {
    activeTab() {
      this.fetch_competition_data(this.$route.params.link)
    }
  },
  methods: {
    fetch_competition_data(link) {
      this.$store.dispatch("competition/fetchCompetitionByLink", link)
        .then(res => { this.competition_data = res.data.data })
        .catch(err => {
          if(err.response.status === 404) {
            this.competition_not_found = true;
            return;
          }
          console.log(err);
        });
    }
  },
  created() {
    this.fetch_competition_data(this.$route.params.link)
  }
}

</script>
